import { ssoClient } from "@better-auth/sso/client"
import { adminClient, organizationClient, twoFactorClient } from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  plugins: [
    organizationClient(),
    twoFactorClient({
      twoFactorPage: "/two-factor",
    }),
    adminClient(),
    ssoClient(),
  ],
})

export const { useSession, signIn, signUp, signOut } = authClient

/**
 * Force `useSession()` to re-fetch GET /get-session.
 *
 * Better Auth 1.5's React client stores the session behind a nanostore atom
 * gated by `$sessionSignal`. Toggling that signal (via `$store.notify`) is
 * what `useAuthQuery` subscribes to — it is the supported way to refresh
 * without a full reload. Invalidating `queryKeys.session()` is a no-op in
 * this codebase: nothing registers that query.
 */
export async function refreshSession(): Promise<void> {
  // Cookie-cached get-session can return a user snapshot up to 5 minutes old
  // (see backend auth.ts session.cookieCache). Preference PUTs write the DB
  // via raw SQL, so a cached Full/English snapshot would snap the UI back.
  // disableCookieCache forces a DB read so Lite / locale / theme stick.
  await authClient.getSession({ query: { disableCookieCache: true } })
  authClient.$store.notify("$sessionSignal")
}
